export const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case "auth/email-already-in-use":
      return "Questa email è già in uso. Per favore prova con un'altra.";
    case "auth/invalid-email":
      return "L'indirizzo email non è valido. Per favore inserisci un indirizzo email valido.";
    case "auth/operation-not-allowed":
      return "Gli account email/password non sono abilitati. Contatta il supporto.";
    case "auth/weak-password":
      return "La password è troppo debole. Per favore inserisci una password più sicura.";
    case "auth/user-disabled":
      return "Questo account utente è stato disabilitato. Contatta il supporto.";
    case "auth/user-not-found":
      return "Nessun utente trovato con questa email. Per favore registrati.";
    case "auth/wrong-password":
      return "Password errata. Per favore prova di nuovo o reimposta la tua password.";
    case "auth/invalid-credential":
      return "Credenziali non valide. Per favore controlla le tue credenziali e prova di nuovo.";
    case "auth/too-many-requests":
      return "L'accesso a questo account è stato temporaneamente disabilitato a causa di troppi tentativi di accesso falliti. Puoi ripristinarlo immediatamente reimpostando la tua password o riprovare più tardi.";
    case "auth/popup-closed-by-user":
      return "Il popup è stato chiuso prima di completare l'accesso. Per favore prova di nuovo.";
    case "auth/cancelled-popup-request":
      return "È consentita solo una richiesta di popup alla volta. Per favore prova di nuovo.";
    case "auth/account-exists-with-different-credential":
      return "Esiste già un account con la stessa email ma con credenziali di accesso diverse. Per favore usa un metodo di accesso diverso.";
    case "auth/invalid-verification-code":
      return "Il codice di verifica non è valido. Per favore prova di nuovo.";
    case "auth/invalid-verification-id":
      return "L'ID di verifica non è valido. Per favore prova di nuovo.";
    case "auth/missing-email":
      return "Per favore fornisci un indirizzo email.";
    case "auth/invalid-action-code":
      return "Il codice di azione non è valido. Per favore prova di nuovo.";
    case "auth/requires-recent-login":
      return "Questa operazione richiede un'autenticazione recente. Per favore effettua di nuovo il login.";
    case "auth/network-request-failed":
      return "Si è verificato un errore di rete. Per favore verifica la tua connessione internet e prova di nuovo.";
    case "auth/credential-already-in-use":
      return "Questa credenziale è già associata a un altro account utente.";
    case "auth/timeout":
      return "L'operazione è scaduta. Per favore prova di nuovo.";

    // firestore database
    case "permission-denied":
      return "Non hai il permesso di accedere a questa risorsa.";
    case "not-found":
      return "Il documento o la risorsa richiesta non esiste.";
    case "aborted":
      return "L'operazione è stata annullata.";
    case "unavailable":
      return "Il servizio non è attualmente disponibile. Per favore riprova più tardi.";
    default:
      return "Si è verificato un errore sconosciuto. Per favore riprova più tardi.";
  }
};
